module.exports = __webpack_public_path__ + "img/MiniLeyes.49c096bc.png";